import React from 'react';
import { Switch } from '@mui/material';
import { GridCellParams } from '@mui/x-data-grid';
import { useSelector } from 'react-redux';
import { selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { shiftDifferentialModStyles } from './ShiftDifferentialMod.style';

const SelectAllComponent = React.memo(function SelectAllComponent(params: any) {
  const isModEdit = useSelector(selectIsEditMod);
  const { classes } = shiftDifferentialModStyles({ isModEdit: isModEdit });
  return (
    <>
      <Switch
        checked={params.value === 'Yes'}
        value={params.value}
        className={isModEdit ? classes.switchPrimary : classes.switchLightBlue}
        disabled={!isModEdit}
      />
      {params.value}
    </>
  );
});

export const SelectAll = (params: GridCellParams) => {
  return <SelectAllComponent {...params} />;
};
